// ie polyfill
// import '@babel/polyfill' 先不考虑ie
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
// import { VueAxios } from './utils/request'
import  './utils/http'
// import  './utils/upload'
import './utils/filter' // global filter
import './core/use'
//引入全局指令文件
import directives from '@/directives'
import delay from './utils/delay'
import dayjs from 'dayjs'

// import './core/lazy_use' 开启按需加载组件
import './permission' // permission control
import util from './util.js'
import BaiduMap from 'vue-baidu-map'
import tim from './initTIM'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
// 全局组件自动注册
import '@/components/tduck/autoRegister'
import '@/style/index.less';
import logger from '@/utils/logger';
import customComponents from '@/components/bjIndex.js';
Vue.use(customComponents);

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls';
Vue.use(VideoPlayer);

Vue.use(util);
Vue.use(delay);
Vue.use(tim);
Vue.use(directives)
Vue.prototype.$tinymce = tinymce
Vue.prototype.$dayjs = dayjs
Vue.use(VueTinymce)
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'zrtGWX4smrETw9WGK3MxL19PQfzTqvOE'
})

Vue.config.productionTip = false;
// Vue.use(axios)
new Vue({
    router,
    store,
    logger,
    render: h => h(App),
}).$mount('#app');
